/**
 * Ensures a value is defined. Returns type safe, defined value if not undefined.
 */
export const ensure = (value, message) => {
    if (value === undefined) {
        throw new Error(message ?? "Expected value was undefined");
    }
    return value;
};
//# sourceMappingURL=ensure.js.map